import React, { useContext, useEffect, useState } from 'react';
import { Layout, Row, Col, Typography, Button, Tooltip, Modal } from 'antd';

import { AppContext } from 'context/AppContext';

import HeaderMain from './HeaderMain';

const { Title } = Typography;
const { Header } = Layout;

const HeaderHome = (props) => {
    let appContext = useContext(AppContext);

    const [visible, setVisible] = useState(false);

    const showDrawer = () => {
        setVisible(true);
    };

    const onClose = () => {
        setVisible(false);
    };

    useEffect(() => {
        if (appContext.defaults.sub_go_pro) {
            setVisible(true);
        }
    }, []);

    return (
        <>
            <Header className="site-layout-background" style={{ padding: 0 }}>
                <HeaderMain />

                <Row
                    className="header-box-shadow"
                    justify="space-between"
                    align="middle"
                >
                    <Col>
                        <Title
                            style={{ marginLeft: 20, paddingTop: 10 }}
                            level={4}
                        >
                            Welcome
                            {appContext.defaults.last_login == null
                                ? ','
                                : ' Back,'}{' '}
                            {appContext.defaults.first_name}
                        </Title>
                    </Col>
                    <Col style={{ paddingRight: 55 }}></Col>
                </Row>
            </Header>
        </>
    );
};

export default HeaderHome;
